interface WebPushViewerIdentity {
  identity: "visitor" | "guest" | "member";
  userId: string | null;
}

export function webPushViewerKey(viewer: WebPushViewerIdentity | undefined) {
  if (!viewer) return "unresolved";
  return `${viewer.identity}:${viewer.userId ?? "none"}`;
}
